"use client";

import { cn, Table, type TableProps } from "@kyan/ui";

import { UnderlyingSymbol } from "#/types/markets";

import { getColumns } from "./LastTradesTable.config";
import type {
  LastTradesTableEntry,
  LastTradesTableVariant,
} from "./LastTradesTable.types";

export interface LastTradesTableProps extends Pick<
  TableProps<LastTradesTableEntry>,
  "isLoading"
> {
  lastTrades: LastTradesTableEntry[];
  variant: LastTradesTableVariant;
  underlying: UnderlyingSymbol | "";
}

export const LastTradesTable = ({
  lastTrades,
  variant,
  underlying,
  isLoading,
}: LastTradesTableProps) => {
  const isOptions = variant === "options";
  const columns = getColumns(underlying, isOptions);

  return (
    <Table
      columns={columns}
      data={lastTrades}
      isLoading={isLoading}
      classes={{
        wrapper: cn("bg-transparent", {
          "border-divider overflow-hidden rounded-b-md border": isOptions,
        }),
        tbody: cn({
          "max-h-[200px] overflow-y-auto": isOptions,
        }),
        table: "border-none",
        thead: cn({
          "border-divider border-b": isOptions,
        }),
        row: "even:bg-buttonBg dark:even:bg-buttonFill border-none mb-px",
        columnClassName: "p-0",
        loading: {
          wrapper: "p-1 border-t-0",
          skeleton: "h-3",
        },
        cellClassName: ({ row }) =>
          cn("h-[18px] p-0 leading-[18px]", {
            "text-error": !row.isBuy,
            "text-success": row.isBuy,
          }),
      }}
    />
  );
};
